import React from 'react';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { fetchmppId, stringifyReasons } from '../../../../helpers';
import { DosageChangeComponent } from '../../../../components/InsightSettings/DosageChange';
import Swal from 'sweetalert2';
import listDetailIcon from '../../../../../assets/img/listDetail.png';
import type { MedicationSetting } from '../../../../../lib/responses/getInsightSettings';
import { usePatientInsightSettings } from '../../../../../context';

interface DosageChangeProps {
  short: boolean;
  closeInsightDetails: () => void;
}
const DosageChangeSection = ({
  short,
  closeInsightDetails,
}: DosageChangeProps) => {
  const [loading, setLoading] = React.useState(false);
  const { insightDetailsContent } = require('../../../../hooks').useUiStore();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const access_token = searchParams.get('access_token');

  const {
    insightSettings,
    selectedTenancy,
    updateSettings,
    fetchInsightSettings,
    refreshTimeline,
  } = usePatientInsightSettings();

  const medicationSettings: MedicationSetting[] =
    insightSettings?.medication_settings ?? [];

  const dosageLog: MedicationSetting[] = medicationSettings
    .filter(
      (x: MedicationSetting) =>
        x.medicinal_product_pack ===
          insightDetailsContent.medicinal_product_pack ||
        x.medicinal_product_pack === insightDetailsContent.mpp_pt,
    )
    .sort((a: MedicationSetting, b: MedicationSetting) => {
      return (b.id ?? 0) - (a.id ?? 0);
    })
    .slice(0, 5);

  const item = insightDetailsContent;
  const lastDosageRecord: MedicationSetting =
    dosageLog.length > 0
      ? dosageLog[0]
      : {
          id: 0,
          created_at: '',
          settings: { dosageQty: 0, dosageFrequency: '' },
          medicinal_product_pack:
            item.medicinal_product_pack ?? item.mpp_pt ?? '',
          mpp_id: item.detail?.mpp_id ?? item.mpp_id,
          created_by_firstname: null,
          created_by_lastname: null,
        };

  const handleSubmit = async (e: any, state: any) => {
    setLoading(true);
    const payload = [
      {
        mpp_id:
          item.detail?.mpp_id ??
          item.mpp_id ??
          fetchmppId(insightSettings!, item),
        settings: {
          dosageQty: Number.parseInt(state.qty),
          dosageFrequency: state.freq,
          dosageChange: true,
        },
      },
    ];

    if (selectedTenancy?.tenancy_id && access_token) {
      await updateSettings(access_token, selectedTenancy.tenancy_id, payload);
      closeInsightDetails();
      await fetchInsightSettings(access_token, selectedTenancy.tenancy_id);
      await Swal.fire({
        title: 'Dosage Changed',
        text: 'Dosage has been updated',
        icon: 'success',
        confirmButtonText: 'OK',
      });
      await refreshTimeline(
        access_token,
        selectedTenancy.tenancy_id,
        moment().add(-2, 'year').format(),
        moment().add(0, 'year').format(),
        true,
      );
    }
    setLoading(false);
  };
  return (
    <>
      {dosageLog && (
        <div className={'group'}>
          <div className="flexHorizWrap">
            <div>
              <img
                alt="listDetail"
                className="imgInsightDetails"
                src={listDetailIcon}
              ></img>
            </div>
            <div>
              <label id="lblActionLog" className="txtLeft">
                Dosage log
              </label>
            </div>
          </div>

          {/*sorting by id although not technically not the right thing , works in this instance easily.*/}
          {dosageLog?.map((log: MedicationSetting, index: number) => {
            return (
              <div key={`${log.created_at}-${index}`}>
                <div className="flexVertWrap">
                  <div>
                    <label
                      className={`txtInsightNotesLine1 ${short ? 'insightNotesShort' : ''}`}
                    >
                      {log.settings?.dosageQty} {log.settings?.dosageFrequency}{' '}
                      - {moment(log.created_at).format('DD MMM YY')}
                    </label>
                  </div>
                  <div>
                    <label
                      className={`txtInsightNotesLine2 ${short ? 'insightNotesShort' : ''}`}
                    >
                      {stringifyReasons(log.settings?.changeReasons || {})}
                    </label>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Render dosage change form popout, consistent with original UI */}
      <div className={'group'}>
        <DosageChangeComponent
          item={lastDosageRecord}
          key={item.id}
          handleSubmit={handleSubmit}
          handleCloseInsight={closeInsightDetails}
          handleCancel={closeInsightDetails}
          popout={true}
          loading={loading}
        />
      </div>
    </>
  );
};

export default DosageChangeSection;
